import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Button } from 'ui-components/components/button';

import { useModal } from '../../../../../../hooks/use-modal';
import { MfaEnrollmentModal } from '../../../../../../components/mfa/mfa-enrollment-modal';
import { messages } from '../messages';
import style from './add-mfa-enrollment.module.less';

/**
 * MFA enrollment component for settings page
 * @param {object} props
 * @param {() => void} props.onSuccess - Called when enrollment succeeds
 * @returns {JSX.Element}
 */
export const AddMfaEnrollment = ({ onSuccess }) => {
  const { isOpen, open, close } = useModal();

  return (
    <>
      <Button className={style['add-new-button']} onClick={open} theme='primary'>
        <FormattedMessage {...messages.buttonAddMfaEnrollment} />
      </Button>
      <MfaEnrollmentModal
        isOpen={isOpen}
        modalTitle={messages.addEnrollmentModalHeader}
        onClose={close}
        onSuccess={onSuccess}
        restrictToMfaType={null}
        showTypeSelection
      />
    </>
  );
};
